<template>
    <BaseDialog
        :showDialog="showDialog"
        maxDialogWidth="500"
        maxCardHeight="900"
        headline="lang_AZ_CAPTION_REASSIGN_CONNECTIONS"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-col>

                    <!-- instruction text and CSV path -->
                    <v-row :alvqa="alvqa + '-text'">
                        {{ $t(showText) }}
                    </v-row>
                    <v-row v-if="csvFileLink !== null" class="pt-4">
                        <a @click="downloadFile(csvFileLink)" class="textLink">
                             {{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}
                        </a>
                    </v-row>

                    <!-- select target A-Z Person -->
                    <v-row class="pt-4">
                        <BaseEditPageDropdown
                            :context="context"
                            field="dropdownAzPersons"
                            :items="getDropdownAzPersons"
                            :clearable="false"
                            :selection="true"
                            :withMargin="false"
                            :returnObject="true"
                            :label="$t('lang_AZ_CAPTION_REASSIGN_CONNECTIONS_SELECT_ONE')"
                            :alvqa="alvqa + '-dropdown-az-persons'"
                        /> 
                    </v-row>

                    <!-- button to start reassignment of connections -->
                    <v-row class="pt-2">
                        <BaseButton 
                            label="lang_BUTTON_START"
                            @click="start"
                            :disabled="startButtonDisabled"
                            :alvqa="alvqa+'-button-start'"
                        />
                    </v-row>
                </v-col>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog               from '@/components/_base/BaseDialog.vue'
import BaseButton               from '@/components/_buttons/BaseButton'
import BaseEditPageDropdown     from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name:"ReassignConnectionsAzPersonsDialog",
    components:{
        BaseDialog,
        BaseButton,
        BaseEditPageDropdown,
    },
    data() {
      return {
        context: 'ReassignAzPersons',
        alvqa: "reassign-connections-dialog",
        csvNotDownloadedYet: true,
      }
  },
   computed:{
        showDialog: {
            get() { return this.$store.getters.getShowAzPersonsReassignConnectionsDialog },
            set(show) { this.$store.commit('setShowAzPersonsReassignConnectionsDialog', show) }
        },
        showText:{
            get() { return this.$store.getters.getReassignConnectionsDialogText },
            set(text) { this.$store.commit('setReassignConnectionsDialogText', text) }
        },
        csvFileLink: { 
            get() { return this.$store.getters.getReassignConnectionsCSVLink },
            set(link) { this.$store.commit('setReassignConnectionsCSVLink', link)}
        },
        getDropdownAzPersons() {
            let completeList = this.$store.getters.getAzPersons
            let selection = this.$store.getters.getSelectedAzPersons
            let finalArray = []
            if(completeList !== undefined) {
                completeList.forEach(element => {
                    if (selection.includes(element.alvId)) {
                        finalArray.push({
                            "value": element.alvId,
                            "text": element.name + ' (' + element.alvId + ')',
                        })
                    }
                });
                return finalArray
            }
        },
        selectedAzPerson() {
            return this.$store.getters.getReassignAzPersonsDetailsdropdownAzPersons
        },
        startButtonDisabled() {
            return this.csvNotDownloadedYet || !this.selectedAzPerson
        }, 
   },
   methods:{
       closeDialog() {
            this.showDialog = false
            this.csvFileLink = null
            this.showText= ''
            this.csvNotDownloadedYet = true
        },
        start() {
            this.$store.dispatch('reassignConnectionsOfSelected')
            this.csvNotDownloadedYet = true
            this.$store.commit('setReassignAzPersonsDetailsdropdownAzPersons', null)
        },
        downloadFile(path) {
            window.location.href = path
            this.csvNotDownloadedYet = false
        },
   },
}
</script>
